<template>
    <div class="channel">
        <div class="left-content">
            <div class="title">
                <a-icon style="margin-right:6px;" type="unordered-list" />
                <span>渠道接入类型选择</span>
            </div>
            <div class="list">
                <div>全部</div>
                <ul>
                    <li :class="{'active':currentTab==item.name}" @click="selectCurrentTab(item.name,item.menu)" v-for="(item, index) in tabList" :key="index">
                        <span>{{item.name}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right-content">
            <div style="width:100%;height:100%;">
                <div class="head">
                    <div class="title">
                        <a-icon type="calendar" style="margin-right:8px;" />
                        <span>[渠道接入]{{currentTab}}</span>
                    </div>
                    <div class="explain" style="font-size:16px;">
                        <a style="text-decoration:none" target="_blank" href="https://www.yuque.com/xiaowenzhineng/ywlhub">
                            <a-icon type="question-circle" style="margin-right:6px;" />
                            <span>配置说明</span>
                        </a>
                    </div>
                </div>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ChannelAccess',
    props: {
        msg: String
    },
    data() {
        return {
            currentMenu: '/ChannelMenu/ChannelAccess',
            currentTab: 'SIP分机登录',
            tabList: [
                {
                    name: 'SIP分机登录',
                    menu: '/ChannelMenu/ChannelAccess'
                },
                {
                    name: '外呼api',
                    menu: '/ChannelMenu/CallApi'
                },
                {
                    name: '在线客服',
                    menu: 'WaitingDevelop'
                },
                {
                    name: '微信公众号',
                    menu: 'WaitingDevelop'
                },
                {
                    name: '微信小程序',
                    menu: 'WaitingDevelop'
                },
                {
                    name: 'SDK',
                    menu: 'WaitingDevelop'
                },
                {
                    name: '微博',
                    menu: 'WaitingDevelop'
                },
                 {
                    name: '抖音企业号码',
                    menu: 'WaitingDevelop'
                },
                 {
                    name: '多模态视频交互',
                    menu: 'WaitingDevelop'
                },
            ],
        };
    },
    methods: {
        selectCurrentTab(name,menu) {
            this.currentTab = name
            if(this.currentMenu != menu){
                this.$router.push(menu)
                this.currentMenu = menu
            }
            
        },
    },
    mounted: function() {
        this.currentTab = sessionStorage.getItem('channelItem')
    },
}
</script>
<style scoped  lang="less">
    .channel{
        display: flex;
        background: rgba(240, 242, 243, 1);
        width: 100%;
        height: 100%;
        .left-content{
            width: 240px;
            background: #fff;
            .title{
                height: 58px;
                color: rgba(170, 170, 170, 1);
                font-size: 14px;
                line-height: 58px;
                padding-left: 24px;
            }
            .list{
                div{
                    height: 48px;
                    line-height: 48px;
                    padding-left: 24px;
                }
                div.active{
                    background: rgba(34, 215, 187, 0.1);
                    color: #22d7bb;
                }
                ul{
                    li{
                        line-height: 48px;
                        height: 48px;
                        color: #505050;
                        font-size: 14px;
                        cursor: pointer;
                        padding-left: 24px;
                    }
                    li.active{
                        background: rgba(34, 215, 187, 0.1);
                        color: #22d7bb;
                        border-right: 2px solid #22d7bb;
                    }
                }
            }
        }
        .right-content{
            padding-bottom: 48px;
            flex: 1;
            // overflow-y: auto;
            padding-bottom: 58px;
            .head{
                height: 58px;
                line-height: 58px;
                font-size: 18px;
                padding: 0 58px 0 24px;
                width: 100%;
                background: #fff;
                .title{
                    color: rgba(51, 51, 51, 1);
                    font-weight: bold;
                    display: inline-block;
                }
                .explain{
                    color: rgba(34, 215, 187, 1);
                    float: right;
                    text-align: right;
                    cursor: pointer;
                }
            }
        }
    }

</style>
